import { render } from "./contactBuy.vue?vue&type=template&id=7ffec7b8&scoped=true"
import script from "./contactBuy.vue?vue&type=script&lang=js"
export * from "./contactBuy.vue?vue&type=script&lang=js"

import "./contactBuy.vue?vue&type=style&index=0&id=7ffec7b8&scoped=true&lang=css"
import "./contactBuy.vue?vue&type=style&index=1&id=7ffec7b8&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffec7b8"]])

export default __exports__